<!-- =========================================================================================
  File Name: VerticalNavMenu.vue
  Description: Vertical NavMenu Component
  Component Name: VerticalNavMenu
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="parentx vertticalmenu">
    <vs-sidebar
      class="v-nav-menu items-no-padding custom-sidebar-main-menu"
      :class="{
        reduced: reduce,
        'sidebar-logged-in': isAuthenticated,
        'sidebar-public-area': !isAuthenticated,
      }"
      v-model="isVerticalNavMenuActive"
      ref="verticalNavMenu"
      default-index="-1"
      :click-not-close="clickNotClose"
      :reduce-not-rebound="reduceNotRebound"
      :reduce-not-hover-expand="mainMenuReduceNotHoverExpand"
      :parent="parent"
      :hiddenBackground="clickNotClose"
      :reduce="reduce"
      v-hammer:swipe.left="onSwipeLeft"
    >
      <!-- <div class="vs-sidebar" :style="sidebarStyle"></div> -->
      <div
        class="content-mouse-event"
        @mouseenter="mouseEnter"
        @mouseleave="mouseLeave"
      >
        <!-- Header -->
        <div
          class="header-sidebar flex items-end justify-between"
          slot="header"
        >
          <!-- Logo -->
          <div
            tag="div"
            class="vx-logo cursor-pointer flex items-center"
            @click.stop="openPopupHelp"
            v-if="!reduce"
          >
            <span class="mr-4 custom-logo logo-full" v-if="logo"></span>

            <span
              class="vx-logo-text"
              v-show="isMouseEnter || !reduce"
              v-if="title"
              >{{ title }}</span
            >
          </div>
          <!-- <router-link
            tag="div"
            class="vx-logo cursor-pointer flex items-center"
            to=""
            @click="$emit('update-current-commodity')"
            v-if="!reduce"
          >
            <span class="mr-4 custom-logo logo-full" v-if="logo"></span>
            <span class="vx-logo-text" v-show="isMouseEnter || !reduce" v-if="title">{{ title }}</span>
          </router-link> -->

          <router-link
            tag="div"
            class="vx-logo cursor-pointer items-center"
            :class="{ flex: !verticalNavMenuItemsMin }"
            to="/"
            v-else
          >
            <span
              class="mr-4 custom-logo logo-full"
              v-if="!verticalNavMenuItemsMin"
            ></span>
            <!-- <img :src="logo" alt="logo" class="mr-4 custom-logo" v-if="!verticalNavMenuItemsMin"/> -->
            <img
              :src="logoReduced"
              alt="logo"
              class="custom-logo-reduced"
              v-if="verticalNavMenuItemsMin"
            />
            <feather-icon
              v-if="verticalNavMenuItemsMin && mainMenuReduceNotHoverExpand"
              id="btnVNavMenuMinToggler"
              class="mr-0 cursor-pointer toggle-vertical-menu-reduced"
              :icon="reduce ? 'CircleIcon' : 'DiscIcon'"
              svg-classes="stroke-current"
              @click.stop="toggleReduce(!reduce)"
            />
          </router-link>
          <!-- /Logo -->

          <!-- Menu Buttons -->
          <div class="user-popp">
            <!-- Close Button -->
            <template v-if="showCloseButton">
              <feather-icon
                icon="XIcon"
                svgClasses="stroke-current text-grey"
                class="close-menu-button"
                @click="
                  $store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
                "
              />
            </template>

            <!-- Toggle Buttons -->
            <template v-else-if="!showCloseButton && !verticalNavMenuItemsMin">
              <feather-icon
                id="btnVNavMenuMinToggler"
                class="mr-0 cursor-pointer custom-toggle-btn"
                :icon="reduce ? 'CircleIcon' : 'DiscIcon'"
                svg-classes="stroke-current"
                @click="toggleReduce(!reduce)"
              />
            </template>
          </div>
          <!-- /Menu Toggle Buttons -->
        </div>
        <!-- /Header -->

        <!-- Header Shadow -->
        <!-- <div class="shadow-bottom" v-show="showShadowBottom"/> -->

        <!-- Mobile Popup Menu User  -->
        <vs-popup
          v-if="!isDesktop && displayPopupMenuUserMobile"
          title
          :active.sync="displayPopupMenuUserMobile"
          class="menu-user-mobile-popup user-config"
          :style="sidebarStyle"
        >
          <menu-user-mobile
            ref="menu-user-mobile"
            :displayData="displayPopupMenuUserMobile"
            @open-login="openLogin"
            @open-register="openRegister"
            @back="displayPopupMenuUserMobile = !displayPopupMenuUserMobile"
            @logout="logout"
            @change-theme="changeThemeMode"
            @open-help="openPopupHelp"
            @open-attendance="openAttendance"
            @open-privacy-policy="openPrivacyPolicyPage"
            @update-platform-zoom-compact="updatePlatformZoomCompact"
            @update-platform-zoom-default="updatePlatformZoomDefault"
            @update-platform-zoom-big="updatePlatformZoomBig"
            @update-platform-zoom-ultra-compact="updatePlatformZoomUltraCompact"
            @changeDisplayTicker="changeDisplayTicker"
            @open-quotes-config="openQuotesConfigHelp"
          ></menu-user-mobile>
        </vs-popup>
        <!-- End of Mobile Popup Menu User  -->

        <!-- User Info Desktop Dropdown -->
        <div class="users-login flex" v-if="!isDesktop" @click="openUserMenu">
          <vs-button
            v-if="isAuthenticated"
            :color="colorx"
            :gradient-color-secondary="colorx2"
            type="gradient"
            icon-pack="feather"
            icon="icon-user"
            @click.stop="
              displayPopupMenuUserMobile = !displayPopupMenuUserMobile
            "
            class="w-full left"
            >{{ user_displayName }} <i class="feather icon-chevron-down"
          /></vs-button>
          <vs-button
            v-if="!isAuthenticated"
            :color="colorx"
            :gradient-color-secondary="colorx2"
            type="gradient"
            icon-pack="feather"
            icon="icon-user"
            @click.stop="
              displayPopupMenuUserMobile = !displayPopupMenuUserMobile
            "
            class="w-full left"
            >{{ $t("BUTTONS").AccessAccount }}
            <i class="feather icon-chevron-down"
          /></vs-button>
          <!-- <feather-icon icon='UserIcon' class=""/> -->
          <!-- <div class="mr-1 pr-1" >
            <vs-avatar :text="getUserName" class="avatar mt-3"></vs-avatar>
          </div>
          <div class="w-full">
            <div class="login-btn mb-1">{{ user_displayName }}</div>
            <div class="config-btn "> <a href="#"> Minha Conta </a></div>
          </div> -->
        </div>

        <!-- <div class="" v-if="isAuthenticated && !isDesktop" @click="displayPopupMenuUserMobile=!displayPopupMenuUserMobile">
          <div class="mr-1 pr-1" >
            <vs-avatar :text="activeUserInfo.nome" class="avatar mt-3"></vs-avatar>
          </div>
          <div class="w-full">
            <div class="login-btn mb-1">{{ user_displayName }}</div>
            <div class="config-btn "> <a href="#"> Minha Conta </a></div>
          </div>
        </div> -->
        <div class="">
          <!-- <feather-icon icon='UserIcon' class=""/> -->
          <!-- <div class="mr-1 pr-1" >
            <vs-avatar :text="activeUserInfo.nome" class="avatar mt-3"></vs-avatar>
          </div>
          <div class="w-full">
            <div class="login-btn mb-1">{{ user_displayName }}</div>
            <div class="config-btn "> <a href="#"> Minha Conta </a></div>
          </div> -->
          <!-- <p><feather-icon icon="UserIcon" svgClasses="w-4 h-4" class="icon-user-profile"></feather-icon></p> -->
          <!-- <p class="font-semibold"></p>
            <p><feather-icon icon="ChevronDownIcon" class="icon-chevron user-icon-chevron" svgClasses="h-4 w-4 ml-1" /></p> -->

          <menu-user-desktop
            v-if="isDesktop"
            :displayData="isDesktop"
            :user_displayName="user_displayName"
            :verticalNavMenuItemsMin="verticalNavMenuItemsMin"
            :reduce="reduce"
            @open-login="openLogin"
            @open-register="openRegister"
            @open-plans="openPlans"
            @open-my-account="openMyAccount"
            @open-signature="openSignatures"
            @open-notification="openNotification"
            @open-change-password="openChangePassword"
            @change-theme="changeThemeMode"
            @open-privacy-policy="openPrivacyPolicyPage"
            @open-help="openPopupHelp"
            @open-attendance="openAttendance"
            @logout="logout"
            @update-zoom-compact="updateZoomCompact"
            @update-zoom-default="updateZoomDefault"
            @update-zoom-big="updateZoomBig"
            @update-format-align-left="updateFormatAlignLeft"
            @update-format-align-center="updateFormatAlignCenter"
            @update-format-align-right="updateFormatAlignRight"
            @update-platform-zoom-compact="updatePlatformZoomCompact"
            @update-platform-zoom-default="updatePlatformZoomDefault"
            @update-platform-zoom-big="updatePlatformZoomBig"
            @update-platform-zoom-ultra-compact="updatePlatformZoomUltraCompact"
            @update-platform-zoom-ultra-big="updatePlatformZoomUltraBig"
            @changeDisplayTicker="changeDisplayTicker"
            @open-quotes-config="openQuotesConfigHelp"
          ></menu-user-desktop>
        </div>
        <!-- <div class="menu-user-dropdown menu-main-user" v-if="isAuthenticated">

          <div class="cursor-pointer dropdown-user" >

            <div
              v-if="!verticalNavMenuItemsMin"
              class="leading-tight sm:block"
              :class="{'menu-username-menu-reduce': reduce}"
            >
              <p class="font-semibold">{{ user_displayName }}</p>
            </div>

          </div>
        </div> -->

        <!-- <div v-if="!isAuthenticated" class="users-login flex justify-center items-center">
          <div class="login-btns w-full" v-if="reduce">
            <vx-tooltip :text="$t('BUTTONS').AccessAccount" position="right" delay=".2s" class="flex cursor-pointer">
              <vs-button color="#333" gradient-color-secondary="rgb(0, 0 ,0)" type="gradient" icon-pack="feather" icon="icon-user" class="mb-1 w-full" @click.stop="$emit('login')"></vs-button>
            </vx-tooltip>
            <vx-tooltip :text="$t('BUTTONS').Register" position="right" delay=".2s" class="flex cursor-pointer">
              <vs-button color="#0fa365" gradient-color-item-detailssecondary="rgb(0, 102 ,58)" type="gradient" icon-pack="feather" icon="icon-user-plus" class="w-full" @click.stop="$emit('open-register')"></vs-button>
            </vx-tooltip>
          </div>
          <div class="login-btns w-full" v-if="!reduce">
            <vs-button color="#333" gradient-color-secondary="rgb(0, 0 ,0)" type="gradient" class="mb-1 w-full" @click.stop="$emit('login')">{{$t('BUTTONS').AccessAccount}}</vs-button>
            <vs-button color="#0fa365" gradient-color-secondary="rgb(0, 102 ,58)" type="gradient" class="w-full" @click.stop="$emit('open-register')">{{$t('BUTTONS').Register}}</vs-button>
          </div>
        </div> -->

        <!-- Menu Items -->
        <div
          :class="['scroll-area-v-nav-menu']"
          :settings="settings"
          @ps-scroll-y="psSectionScroll"
        >
          <template v-for="(item, index) in menuItemsUpdated">
            <!-- Group Header -->
            <span
              style="display: none"
              v-if="item.header && !verticalNavMenuItemsMin"
              class="navigation-header"
              :key="`header-${index}`"
              >{{ $t(item.i18n)[item.i18nData] || item.header }}</span
            >
            <!-- /Group Header -->

            <template v-else-if="item.divider">
              <vs-divider class="custom-divider-menu" :key="index"></vs-divider>
            </template>

            <template v-else-if="!item.header">
              <!-- Nav-Item -->
              <template v-if="isWindowDetached">
                <v-nav-menu-item
                  v-if="!item.submenu"
                  :key="`item-${index}`"
                  :index="index"
                  :icon="item.icon"
                  :isDisabled="item.isDisabled"
                  :icone="item.icone"
                  :slug="item.slug"
                  :name="item.name"
                  :sidebarActive="verticalNavMenuItemsMin"
                  :currentItem="item"
                  :isWindowDetached="true"
                >
                  <span v-show="!verticalNavMenuItemsMin" class="icon-menu">{{
                    $t(item.i18n)[item.i18nData] || item.name
                  }}</span>
                  <vs-chip
                    class="ml-auto"
                    :color="item.tagColor"
                    v-if="item.tag && (isMouseEnter || !reduce)"
                    >{{ item.tag }}
                  </vs-chip>
                </v-nav-menu-item>
                <!-- Nav-Group -->
                <template v-else>
                  <v-nav-menu-group
                    :key="`group-${index}`"
                    :openHover="openGroupHover"
                    :group="item"
                    :icone="item.icone"
                    :groupIndex="index"
                    :isDisabled="item.isDisabled"
                    :open="isGroupActive(item)"
                  />
                </template>
              </template>
              <template v-else>
                <v-nav-menu-item
                  v-if="!item.submenu"
                  :key="`item-${index}`"
                  :index="index"
                  :to="item.slug !== 'external' ? item.url : null"
                  :href="item.slug === 'external' ? item.url : null"
                  :icon="item.icon"
                  :target="item.target"
                  :isDisabled="item.isDisabled"
                  :icone="item.icone"
                  :slug="item.slug"
                  :name="item.name"
                  :sidebarActive="verticalNavMenuItemsMin"
                  :currentItem="item"
                  :isWindowDetached="false"
                >
                  <span v-show="!verticalNavMenuItemsMin" class="icon-menu">{{
                    $t(item.i18n)[item.i18nData] || item.name
                  }}</span>
                  <vs-chip
                    class="ml-auto"
                    :color="item.tagColor"
                    v-if="item.tag && (isMouseEnter || !reduce)"
                    >{{ item.tag }}
                  </vs-chip>
                </v-nav-menu-item>
                <!-- Nav-Group -->
                <template v-else>
                  <v-nav-menu-group
                    :key="`group-${index}`"
                    :openHover="openGroupHover"
                    :group="item"
                    :icone="item.icone"
                    :groupIndex="index"
                    :isDisabled="item.isDisabled"
                    :open="isGroupActive(item)"
                  />
                </template>
              </template>

              <!-- /Nav-Group -->
            </template>
          </template>
        </div>
        <!-- /Menu Items -->
        <!-- <div v-if="!verticalNavMenuItemsMin"> -->
        <the-footer
          :verticalNavMenuItemsMin="verticalNavMenuItemsMin"
          @displayPopupHelp="openPopupHelp"
          @displayPopupAttendance="openAttendance"
        />
        <!-- <div>
        </div> -->
      </div>
    </vs-sidebar>

    <vs-popup
      :title="!isDesktop ? helpModalTitle : ''"
      :active.sync="displayPopupHelp"
      id="pop-user"
      class="about-system"
      :class="{
        'pop-user': !isDesktop,
        desktop: isDesktop,
        authenticated: isAuthenticated,
      }"
    >
      <div v-if="displayPopupHelp" @contextmenu.prevent style="height: 100%">
        <Help
          :openAttendance="openHelpTabAttendance"
          :openPrivacyPolicy="openPrivacyPolicy"
          :openQuotesConfig="openQuotesConfig"
          :attendanceText="attendanceText"
          @close="displayPopupHelp = false"
          @update-modal-title="updateModalTitle"
        ></Help>
      </div>
    </vs-popup>

    <!-- <div class="main-menu-icon-toggled" @click.stop="toggleMenu" v-if="!isDesktop">
      <feather-icon icon="MenuIcon" class="inline-block mr-2" svgClasses="w-8 h-10"/>
    </div> -->

    <!-- Swipe Gesture -->
    <div
      v-if="!isVerticalNavMenuActive"
      class="v-nav-menu-swipe-area"
      v-hammer:swipe.right="onSwipeAreaSwipeRight"
    />

    <!-- /Swipe Gesture -->
  </div>
</template>

<script>
import TheFooter from "@/layouts/components/TheFooter.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VNavMenuGroup from "./VerticalNavMenuGroup.vue";
import VNavMenuItem from "./VerticalNavMenuItem.vue";
import localStorageHelper from "../../../helpers/local-storage-helper";
import authService from "../../../providers/authService";
import AppConstants from "../../../appConstants";
import Help from "../../../views/pages/help/Help.vue";
import MenuUserMobile from "../../../views/pages/MenuUserMobile.vue";
import MenuUserDesktop from "../../../views/pages/MenuUserDesktop.vue";
import { EventBus } from "../../../event-bus";
import Flags from "../../../components/translate/Flags";
import ChangeZoom from "../../../plugins/ChangeZoom";
import { getInsetStyle } from "../../../helpers/inset-style-helper";

export default {
  name: "v-nav-menu",
  components: {
    VNavMenuGroup,
    VNavMenuItem,
    VuePerfectScrollbar,
    TheFooter,
    Help,
    Flags,
    MenuUserMobile,
    MenuUserDesktop,
  },
  props: {
    logo: { type: String },
    logoReduced: { type: String },
    openGroupHover: { type: Boolean, default: false },
    parent: { type: String },
    reduceNotRebound: { type: Boolean, default: true },
    navMenuItems: { type: Array, required: true },
    title: { type: String },
    mainMenuReduceNotHoverExpand: { type: Boolean, default: false },
  },
  data: () => ({
    helpModalTitle: "SAFRAS & MERCADO",
    displayPopupMenuUserMobile: false,
    displayPopupHelp: false,
    attendanceText: "",
    clickNotClose: false, // disable close navMenu on outside click
    isMouseEnter: false,
    reduce: false, // determines if navMenu is reduce - component property
    showCloseButton: false, // show close button in smaller devices
    settings: {
      // perfectScrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed: 1,
      swipeEasing: true,
    },
    showShadowBottom: false,
    openHelpTabAttendance: false,
    openPrivacyPolicy: false,
    openQuotesConfig: false,
    colorx: "#00663b",
    colorx2: "#afca0d",
    canDisplayToggleReduce: true,
  }),
  computed: {
    sidebarStyle() {
      return getInsetStyle();
    },
    isWindowDetached() {
      return !!this.$route.query.currentCommodity;
    },
    canDisplayTicker: {
      get() {
        return this.$store.state.canDisplayTicker;
      },
      set(val) {
        this.$store.dispatch("canDisplayTicker", val);
        this.$forceUpdate();
      },
    },
    s4Login() {
      return localStorageHelper.getS4Login();
    },
    isDesktop() {
      return this.$store.state.isDesktop;
    },
    currentTheme() {
      if (this.$store.state.theme === AppConstants.THEME.DARK) {
        return this.$t("NAVBAR_DROPDOWN_MENU").Light_Theme;
      }
      return this.$t("NAVBAR_DROPDOWN_MENU").Dark_Theme;
    },
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
    themeMode: {
      get() {
        return this.$store.state.theme === AppConstants.THEME.DARK;
      },
      set(val) {
        let theme;
        if (val) {
          theme = AppConstants.THEME.DARK;
        } else {
          theme = AppConstants.THEME.LIGHT;
        }
        localStorageHelper.updateTheme(theme);
      },
    },
    isGroupActive() {
      return (item) => {
        const path = this.$route.fullPath;
        const routeParent = this.$route.meta
          ? this.$route.meta.parent
          : undefined;
        let open = false;

        let func = (item) => {
          if (item.submenu) {
            item.submenu.forEach((item) => {
              if (
                item.url &&
                (path === item.url || routeParent === item.slug)
              ) {
                open = true;
              } else if (item.submenu) {
                func(item);
              }
            });
          }
        };
        func(item);
        return open;
      };
    },
    menuItemsUpdated() {
      let clone = this.navMenuItems.slice();

      for (let [index, item] of this.navMenuItems.entries()) {
        if (item.header && item.items.length && (index || 1)) {
          let i = clone.findIndex((ix) => ix.header === item.header);
          for (let [subIndex, subItem] of item.items.entries()) {
            clone.splice(i + 1 + subIndex, 0, subItem);
          }
        }
      }

      return clone;
    },
    isVerticalNavMenuActive: {
      get() {
        return this.$store.state.isVerticalNavMenuActive;
      },
      set(val) {
        if (val) {
          this.applyMenuSidebarStyles();
        }
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", val);
      },
    },
    layoutType() {
      return this.$store.state.mainLayoutType;
    },
    reduceButton: {
      get() {
        return this.$store.state.reduceButton;
      },
      set(val) {
        this.$store.commit("TOGGLE_REDUCE_BUTTON", val);
      },
    },
    isVerticalNavMenuReduced() {
      return Boolean(this.reduce && this.reduceButton);
    },
    verticalNavMenuItemsMin() {
      return this.$store.state.verticalNavMenuItemsMin;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    // PROFILE
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    user_displayName() {
      let displayName;
      const maxLength = 18;
      displayName = this.activeUserInfo.email;

      // if (this.activeUserInfo.nome) {
      //   displayName = this.activeUserInfo.nome;
      // } else {
      //   displayName = this.activeUserInfo.email;
      // }

      if (displayName) {
        if (displayName.length > maxLength) {
          return displayName.substring(0, maxLength) + "...";
        } else {
          return displayName;
        }
      }

      return "";
    },
    getUserName() {
      if (!this.activeUserInfo.nome) {
        return "";
      }
      const split = this.activeUserInfo.nome.split(" ");
      return `${split[0]} ${split[split.length - 1]}`;
    },
  },
  watch: {
    displayPopupHelp(val) {
      if (!val) {
        this.helpModalTitle = "SAFRAS & MERCADO";
      }
    },
    $route() {
      if (this.isVerticalNavMenuActive && this.showCloseButton)
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
    },
    reduce(val) {
      const verticalNavMenuWidth = val ? "reduced" : "default";
      this.$store.dispatch("updateVerticalNavMenuWidth", verticalNavMenuWidth);

      setTimeout(function () {
        window.dispatchEvent(new Event("resize"));
      }, 100);
    },
    layoutType() {
      this.setVerticalNavMenuWidth();
    },
    reduceButton() {
      this.setVerticalNavMenuWidth();
    },
    windowWidth() {
      this.setVerticalNavMenuWidth();
    },
  },
  methods: {
    applyMenuSidebarStyles() {
      this.$nextTick(() => {
        // Seleciona a div principal do sidebar
        const vsSidebarRoot =
          this.$refs.verticalNavMenu && this.$refs.verticalNavMenu.$el;
        if (vsSidebarRoot) {
          const sidebar = vsSidebarRoot.querySelector(".vs-sidebar");
          console.log("[applyMenuSidebarStyles]", sidebar);
          if (sidebar) {
            if (this.$store.state.insetTop)
              sidebar.style.top = `${this.$store.state.insetTop}px`;
            if (this.$store.state.insetBottom)
              sidebar.style.bottom = `${this.$store.state.insetBottom}px`;
            const scrollArea = vsSidebarRoot.querySelector(
              ".scroll-area-v-nav-menu"
            );
            const footer = vsSidebarRoot.querySelector(".the-footer");
            // sidebar.style.setProperty("height", "auto", "important");
            sidebar.style.maxHeight = "100%";
            sidebar.style.setProperty(
              "height",
              `calc(100vh - ${
                Number(this.$store.state.insetTop) +
                Number(this.$store.state.insetBottom)
              }px)`,
              "important"
            );

            if (scrollArea) {
              scrollArea.style.setProperty(
                "height",
                `calc(100% - ${154 + Number(this.$store.state.insetTop)}px)`,
                "important"
              );
              // console.log('[applyMenuSidebarStyles] scrollArea height', height);
            }

            if (footer) {
              footer.style.position = "absolute";
              footer.style.bottom = "0";
              footer.style.width = "100%";
              footer.style.zIndex = "1";
            }
          }
        }
      });
    },
    changeDisplayTicker() {
      this.canDisplayTicker = !this.canDisplayTicker;
    },
    closeMenuUserMobile(val) {
      this.displayPopupMenuUserMobile = val;
    },
    updateModalTitle(title) {
      // console.log('[updateModalTitle]', title);
      if (!title) {
        this.helpModalTitle = "SAFRAS & MERCADO";
      }

      this.helpModalTitle = title;
    },
    openLogin() {
      this.displayPopupHelp = false;
      this.closeMenuUserMobile(false);
      this.$emit("login");
    },
    openRegister() {
      this.displayPopupHelp = false;
      this.closeMenuUserMobile(false);
      this.$emit("open-register");
    },
    openPlans() {
      this.displayPopupHelp = false;
      this.closeMenuUserMobile(false);
      this.$emit("open-plans");
    },
    openUserMenu() {
      if (!this.isDesktop) {
        this.closeMenuUserMobile(true);
      }
    },
    openPopupHelp() {
      this.displayPopupHelp = true;
      this.openHelpTabAttendance = false;
      this.openPrivacyPolicy = false;
      this.openQuotesConfig = false;
    },
    changeThemeMode() {
      this.themeMode = !this.themeMode;
    },
    openAttendance(text) {
      this.attendanceText = text;
      this.displayPopupHelp = true;
      this.openHelpTabAttendance = true;
      this.openPrivacyPolicy = false;
      this.openQuotesConfig = false;
    },
    openQuotesConfigHelp() {
      this.openHelpTabAttendance = false;
      this.openPrivacyPolicy = false;
      this.openQuotesConfig = true;
      this.displayPopupHelp = true;
    },
    toggleMenu() {
      // console.log("toggleMenu");
      this.isVerticalNavMenuActive = true;
    },
    logout() {
      if (!this.isDesktop) {
        this.closeMenuUserMobile(false);
        setTimeout(() => {
          authService.logout();
        }, 100);
      } else {
        authService.logout();
      }
    },
    openChangePassword() {
      this.displayPopupHelp = false;
      this.closeMenuUserMobile(false);
      this.$router.push(AppConstants.NAVIGATION_PAGE_ACCOUNT_CHANGE_PASSWORD);
    },
    openPrivacyPolicyPage() {
      this.openHelpTabAttendance = false;
      this.openQuotesConfig = false;
      this.openPrivacyPolicy = true;
      this.displayPopupHelp = true;
      // if (!this.isDesktop) {
      //   this.displayPopupMenuUserMobile = false;
      // }
      // this.$router.push(AppConstants.NAVIGATION_PAGE_ACCOUNT_PRIVACY_POLICY);
    },
    openSignatures() {
      this.displayPopupHelp = false;
      this.closeMenuUserMobile(false);
      this.$router.push(AppConstants.NAVIGATION_PAGE_ACCOUNT_SIGNATURE);
    },
    openNotification() {
      this.displayPopupHelp = false;
      this.closeMenuUserMobile(false);
      this.$router.push(AppConstants.NAVIGATION_PAGE_ACCOUNT_NOTIFICATION);
    },
    openMyAccount() {
      this.displayPopupHelp = false;
      this.closeMenuUserMobile(false);
      this.$router.push(AppConstants.NAVIGATION_PAGE_ACCOUNT);
    },
    goToAskToAnalyst() {
      this.displayPopupHelp = false;
      this.$router.push(AppConstants.NAVIGATION_PAGE_ASK_TO_ANALYST);
    },
    // handleWindowResize(event) {
    //   this.windowWidth = event.currentTarget.innerWidth;
    //   this.setVerticalNavMenuWidth()
    // },
    onSwipeLeft() {
      if (this.isVerticalNavMenuActive && this.showCloseButton)
        this.isVerticalNavMenuActive = false;
    },
    onSwipeAreaSwipeRight() {
      if (!this.isVerticalNavMenuActive && this.showCloseButton)
        this.isVerticalNavMenuActive = true;
    },
    psSectionScroll() {
      this.showShadowBottom =
        this.$refs.verticalNavMenuPs.$el.scrollTop > 0 ? true : false;
    },
    mouseEnter() {
      if (!this.mainMenuReduceNotHoverExpand) {
        if (this.reduce) {
          this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", false);
        }
        this.isMouseEnter = true;
      }
    },
    mouseLeave() {
      if (!this.mainMenuReduceNotHoverExpand) {
        if (this.reduce) {
          this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", true);
        }
        this.isMouseEnter = false;
      }
    },
    setVerticalNavMenuWidth(toggle = false) {
      if (this.windowWidth > 1360) {
        // this.canDisplayToggleReduce = true;
        if (this.layoutType === "vertical") {
          // Set reduce
          this.reduce = this.reduceButton ? true : false;

          // Open NavMenu
          this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);

          // Set Menu Items Only Icon Mode
          const verticalNavMenuItemsMin =
            this.reduceButton && !this.isMouseEnter ? true : false;
          this.$store.commit(
            "UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN",
            verticalNavMenuItemsMin
          );

          // Menu Action buttons
          this.clickNotClose = true;
          this.showCloseButton = false;

          const verticalNavMenuWidth = this.isVerticalNavMenuReduced
            ? "reduced"
            : "default";
          this.$store.dispatch(
            "updateVerticalNavMenuWidth",
            verticalNavMenuWidth
          );

          return;
        }
      } else {
        if (!this.isDesktop) {
          // Close NavMenu
          // this.reduce = this.reduceButton ? true : false;

          this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);

          // Reduce button
          if (this.reduceButton) this.reduce = false;

          // Menu Action buttons
          this.showCloseButton = true;
          this.clickNotClose = false;

          // Update NavMenu Width
          this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");

          // Remove Only Icon in Menu
          this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", false);
          return;
        }

        if (!this.reduce) {
          // when reduce window width, will run this conditional to collapse menu
          this.reduce = true;
          // this.reduce = this.reduceButton ? true : false;

          // Set Menu Items Only Icon Mode
          const verticalNavMenuItemsMin =
            this.reduceButton && !this.isMouseEnter ? true : false;
          this.$store.commit(
            "UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN",
            verticalNavMenuItemsMin
          );

          this.clickNotClose = true;
          this.showCloseButton = false;

          // this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu');
          this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", true);

          const verticalNavMenuWidth = this.isVerticalNavMenuReduced
            ? "reduced"
            : "default";
          this.$store.dispatch(
            "updateVerticalNavMenuWidth",
            verticalNavMenuWidth
          );
        }
      }

      if (this.windowWidth < 1360 && toggle) {
        // console.log('toggle here');
        // Set reduce
        this.reduce = false;

        // Open NavMenu
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);

        // Set Menu Items Only Icon Mode
        // const verticalNavMenuItemsMin = this.reduceButton && !this.isMouseEnter ? true : false;
        this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", false);

        // Menu Action buttons
        this.clickNotClose = true;
        this.showCloseButton = false;

        // const verticalNavMenuWidth = this.isVerticalNavMenuReduced ? "reduced" : "default";
        this.$store.dispatch("updateVerticalNavMenuWidth", "default");
      }

      // Open NavMenu
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);

      // Remove at this point

      // if(this.layoutType === 'vertical' || (this.layoutType === 'horizontal' && this.windowWidth < 1200))
      // if (this.windowWidth < 1200) {

      //   // Close NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)

      //   // Reduce button
      //   if (this.reduceButton) this.reduce = false

      //   // Menu Action buttons
      //   this.showCloseButton = true
      //   this.clickNotClose   = false

      //   // Update NavMenu Width
      //   this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

      //   // Remove Only Icon in Menu
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)

      // } else {

      //   // Set reduce
      //   this.reduce = this.reduceButton ? true : false

      //   // Open NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)

      //   // Set Menu Items Only Icon Mode
      //   const verticalNavMenuItemsMin = (this.reduceButton && !this.isMouseEnter) ? true : false
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin)

      //   // Menu Action buttons
      //   this.clickNotClose   = true
      //   this.showCloseButton = false

      //   const verticalNavMenuWidth   = this.isVerticalNavMenuReduced ? "reduced" : "default"
      //   this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)
      // }
    },
    toggleReduce(val) {
      this.reduceButton = val;
      // this.reduce = val;
      // console.log('[this.reduceButton]', this.reduceButton)
      // console.log('[this.reduce]', this.reduce)
      EventBus.$emit(AppConstants.BUS_EVENT_UPDATE_HIGHLIGHTS);
      this.setVerticalNavMenuWidth(true);
      localStorageHelper.setSidebarMainMenu(this.reduce);
      //UPDATE WIDTH HIGHLIGHTS
      setTimeout(() => {
        EventBus.$emit(AppConstants.BUS_EVENT_REFRESH);
      }, 250);
    },
    updateFormatAlignLeft() {
      localStorageHelper.updateFormatAlignDetail(
        AppConstants.DETAIL_FORMAT_ALIGN.LEFT
      );
    },
    updateFormatAlignCenter() {
      localStorageHelper.updateFormatAlignDetail(
        AppConstants.DETAIL_FORMAT_ALIGN.CENTER
      );
    },
    updateFormatAlignRight() {
      localStorageHelper.updateFormatAlignDetail(
        AppConstants.DETAIL_FORMAT_ALIGN.RIGHT
      );
    },
    updatePlatformZoomUltraBig() {
      ChangeZoom.setUltraBig();
    },
    updatePlatformZoomUltraCompact() {
      ChangeZoom.setUltraCompact();
    },
    updatePlatformZoomCompact() {
      ChangeZoom.setCompact();
    },
    updatePlatformZoomDefault() {
      ChangeZoom.setDefault();
    },
    updatePlatformZoomBig() {
      ChangeZoom.setBig();
    },
    updateZoomCompact() {
      ChangeZoom.setDetailCompact();
    },
    updateZoomDefault() {
      ChangeZoom.setDetailDefault();
    },
    updateZoomMedium() {
      ChangeZoom.setDetailMedium();
    },
    updateZoomBig() {
      ChangeZoom.setDetailBig();
    },
    openPlansMobile() {
      this.closeMenuUserMobile(true);
      this.$nextTick(() => {
        if (this.$refs["menu-user-mobile"]) {
          this.$refs["menu-user-mobile"].openPlans();
        }
      });
    },
    openUserSignaturesMobile() {
      this.closeMenuUserMobile(true);
      this.$nextTick(() => {
        if (this.$refs["menu-user-mobile"]) {
          this.$refs["menu-user-mobile"].openUserSignaturesMobile();
        }
      });
    },
  },
  created() {
    // console.log('[sidebarStyle]',this.$store.state.insetTop);
    // console.log('[sidebarStyle]',this.$store.state.insetBottom);
    // this.$refs.verticalNavMenu
  },
  mounted() {
    this.setVerticalNavMenuWidth();
    this.reduceButton = localStorageHelper.getSidebarMainMenuReduce();

    EventBus.$on(AppConstants.BUS_EVENT_TOGGLE_REDUCE_MAIN_MENU, (val) => {
      console.log("[menu reduced] ", val);
      // Set reduce
      this.reduce = val;
      this.reduceButton = val;

      // Open NavMenu
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", val);

      // Set Menu Items Only Icon Mode
      const verticalNavMenuItemsMin =
        this.reduceButton && !this.isMouseEnter ? true : false;
      this.$store.commit(
        "UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN",
        verticalNavMenuItemsMin
      );

      // Menu Action buttons
      this.clickNotClose = val;
      this.showCloseButton = !val;

      const verticalNavMenuWidth = this.isVerticalNavMenuReduced
        ? "reduced"
        : "default";
      this.$store.dispatch("updateVerticalNavMenuWidth", verticalNavMenuWidth);
      // this.setVerticalNavMenuWidth(val);
      // this.reduce = val;
      // this.toggleReduce(val);
    });

    EventBus.$on(AppConstants.BUS_EVENT_CLOSE_POPUP, () => {
      this.displayPopupHelp = false;
    });

    EventBus.$on(AppConstants.BUS_EVENT_OPENA_ATTENDANCE, (text) => {
      this.openAttendance(text);
    });

    EventBus.$on(AppConstants.BUS_EVENT_OPEN_USER_MENU_MOBILE, () => {
      this.openUserMenu();
    });

    EventBus.$on(AppConstants.BUS_EVENT_HEADER_MOBILE_OPEN_MAIN_MENU, () => {
      this.toggleMenu();
    });

    if (!this.isDesktop) {
      EventBus.$on(AppConstants.BUS_EVENT_OPEN_PLANS_MOBILE, () => {
        this.openPlansMobile();
      });
      EventBus.$on(AppConstants.BUS_EVENT_OPEN_USER_SIGNATURES_MOBILE, () => {
        this.openUserSignaturesMobile();
      });
    }
  },
  beforeDestroy() {
    // stop listening event
    EventBus.$off(AppConstants.BUS_EVENT_TOGGLE_REDUCE_MAIN_MENU);
    EventBus.$off(AppConstants.BUS_EVENT_CLOSE_POPUP);
    EventBus.$off(AppConstants.BUS_EVENT_OPENA_ATTENDANCE);
    EventBus.$off(AppConstants.BUS_EVENT_HEADER_MOBILE_OPEN_MAIN_MENU);
    EventBus.$off(AppConstants.BUS_EVENT_OPEN_USER_MENU_MOBILE);
    if (!this.isDesktop) {
      EventBus.$off(AppConstants.BUS_EVENT_OPEN_PLANS_MOBILE);
      EventBus.$off(AppConstants.BUS_EVENT_OPEN_USER_SIGNATURES_MOBILE);
    }
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/verticalNavMenu.scss";

.con-vs-dropdown--menu {
  z-index: 9999999;
}

.v-nav-menu .scroll-area-v-nav-menu {
  height: calc(100vh - 240px);
  margin-top: 0px;
}

.scroll-area-v-nav-menu {
  &::-webkit-scrollbar {
    width: 6px;
    height: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #aaa;
    border-radius: 20px;

    .theme-dark & {
      background: #626262;
    }
  }

  &::-webkit-scrollbar-track {
    background: $theme-background;
    border-radius: 30px;

    .theme-dark & {
      background: #282e34;
    }
  }
}

.sidebar-logged-in .scroll-area-v-nav-menu {
  height: calc(99vh - 200px);
  overflow-y: auto;
}

.reduced.sidebar-logged-in .scroll-area-v-nav-menu {
  height: calc(100vh - 240px);
}

.sidebar-public-area .scroll-area-v-nav-menu {
  height: calc(98vh - 200px);
  overflow-y: auto;
}

.reduced.sidebar-public-area .scroll-area-v-nav-menu {
  height: calc(100vh - 250px);
}

.mobile .sidebar-public-area .scroll-area-v-nav-menu {
  height: calc(100vh - 185px) !important;
}

.mobile .sidebar-logged-in .scroll-area-v-nav-menu {
  height: calc(100vh - 190px) !important;
}

.menu-avatar-menu-reduce {
  margin-left: 5px;
}

.close-menu-button {
  position: absolute !important;
  right: -2px;
  top: 10px;
}

#help-popup {
  .vs-tabs-position-left .vs-tabs--ul {
    width: 260px;
    background-color: #f8f8f8;
    height: 445px;
    padding: 20px;
  }

  .vs-popup--content {
    margin-top: 0px;
    height: 100%;
    border-radius: 6px;
  }

  .vs-popup--header {
    // display: none;
    height: 0px;
    background-color: #fff;
  }

  .vs-popup--close {
    // margin-top: 20px;
  }

  .vs-popup {
    width: 800px;
    height: 450px;
  }
}

.help-mobile {
  .vs-popup {
    // height: 80% !important;
    height: 100% !important;
    width: 100% !important;
    margin: 0px !important;
    max-width: 100%;
    max-height: 100%;
  }

  .con-vs-tabs .con-slot-tabs {
    width: 100%;
  }
}

.con-slot-tabs {
  // margin: 15px;
  padding-bottom: 25px;
  padding-top: 25px;
}

span.line-vs-tabs {
  margin-right: 40px;
  /* margin-top: 20px; */
}

.vs-component.con-vs-popup.about-system.vs-popup-primary .vs-popup header {
  // display: none;
}

.icons-sub-menu {
  margin-top: 0px;
}

.vs-component.con-vs-popup.about-system.vs-popup-primary
  .vs-popup
  .vs-popup--content {
  padding: 0px;
}

.user-account {
  background-color: #353e45;
  border-radius: 50px;
  width: 40px;
  height: 40px;
  color: #fff;
}

.user-account svg {
  color: #fff;
  font-size: 1.5em;
}

.theme-dark .icon-user-profile.feather-icon.select-none.relative svg {
  color: #fff;
}

.theme-dark .icon-chevron.feather-icon.select-none.relative {
  color: #fff;
}

.user-icon-chevron {
  position: absolute !important;
  right: 0px;
}

.menu-main-user {
  margin-left: 30px;
  margin-bottom: 10px;
  margin-top: 10px;
}

#dropdown-user-flags {
  display: flex;

  #flags {
    margin-top: 3px;
    margin-left: 5px;
  }
}

.content-mouse-event {
  height: 100%;
  background-color: #f3f3f3;
}

.theme-dark .content-mouse-event {
  background-color: #2f363d;
}

.theme-dark #help-popup .vs-tabs-position-left .vs-tabs--ul {
  background-color: #353e45;
}

.custom-divider-menu {
  margin: 10px 17px 0px 12px;
  width: 90%;
}

.toggle-vertical-menu-reduced {
  padding-top: 3px;
  padding-left: 8px;
}

.dropdown-user-menu-reduced {
  left: 200px !important;
  top: 10% !important;

  .vs-dropdown--menu--after {
    display: none;
    // left: 55px;
    // left: 90px;
    // top: 40px !important;
  }
}
</style>
